module.exports = __webpack_public_path__ + "img/banner-1-m.57417815.jpg";